<template>
  <Bmap
    ref="bmap"
    :initPoint="initPoint"
    :revisability="false"
    :hasSearch="false"
    :hasThemeSwitcher="false"
    @mapHandler="mapHandler"
  />
</template>

<script>
import Bmap from '@/components/bmap';
import { mapGetters } from 'vuex';
import { getSmokePuff } from '@/api/devices';
import { stateMapMarker as smm } from '@/utils/dict';

export default {
  name: 'PuffMap',
  data() {
    return {
      initPoint: {}
    };
  },
  components: { Bmap },
  computed: {
    ...mapGetters('socket', ['currentChooseDevice'])
  },
  methods: {
    mapHandler(theme) {
      getSmokePuff(this.$route.params.sn)
        .then(res => {
          if (res.data) {
            const { center } = res.data[this.$route.params.sn];
            // eslint-disable-next-line no-undef
            this.initPoint = new BMap.Point(center.xcoord, center.ycoord);

            const bmap = this.$refs['bmap'].bmap;
            const device = this.currentChooseDevice;

            // eslint-disable-next-line no-undef
            bmap.centerAndZoom(this.initPoint, 11);
            if (theme) bmap.setMapStyleV2({ styleJson: theme });
            for (let sn in res.data) {
              const { center, payload } = res.data[sn];
              for (let i = 0, len = payload.length; i < len; i++) {
                const { color, coords } = payload[i];
                // eslint-disable-next-line no-undef
                const cPayload = new BMap.Polygon(
                  [
                    // eslint-disable-next-line no-undef
                    new BMap.Point(coords[0][0], coords[0][1]),
                    // eslint-disable-next-line no-undef
                    new BMap.Point(coords[1][0], coords[1][1]),
                    // eslint-disable-next-line no-undef
                    new BMap.Point(coords[2][0], coords[2][1]),
                    // eslint-disable-next-line no-undef
                    new BMap.Point(coords[3][0], coords[3][1])
                  ],
                  {
                    strokeColor: color,
                    fillColor: color
                  }
                );
                bmap.addOverlay(cPayload);
              }
              // eslint-disable-next-line no-undef
              const label = new BMap.Label(sn, {
                position: new BMap.Point(center.xcoord, center.ycoord),
                offset: new BMap.Size(0, -50)
              });
              label.setStyle({
                color: '#000',
                fontSize: '16px',
                border: '2px solid #1E90FF',
                transform: 'translateX(-50%)',
                borderRadius: '8px',
                padding: '2px 5px'
              });
              bmap.addOverlay(label);

              const marker = new BMap.Marker(new BMap.Point(device.longitude, device.latitude), {
                icon: new BMap.Icon(smm[device.state], new BMap.Size(32, 32)),
                offset: new BMap.Size(0, -16)
              });
              bmap.addOverlay(marker);
            }
          } else {
            this.$message({
              type: 'warning',
              message: '暂无数据'
            });
          }
        })
        .finally(() => {
          this.$emit('closeLoading');
        });
    }
  }
};
</script>
